module.exports = __webpack_public_path__ + "static/media/guest-collection-empty-phone.dfde8bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guestlist/guest-collection-empty-phone.png
// module id = 2336
// module chunks = 71